import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useHistory, useParams } from 'react-router';
import { connect } from 'react-redux';
import { Col, Dropdown, DropdownMenu, DropdownItem, DropdownToggle, Row } from 'reactstrap';
import { getWeekNameDate } from 'lib/time';
import getContent from 'lib/getContent';
import { getProductFromPath } from '../../utils';

const MAX_RECENT_WEEKS = 5;

const WeekNav = ({ authToken, product, slug }) => {
  const history = useHistory();
  const params = useParams();
  const urlSlug = params.slug;
  const productInPath = getProductFromPath();

  const [isOpen, setIsOpen] = useState(false);
  const [sortedWeeksList, setSortedWeeksList] = useState(null);
  const [thisWeek, setThisWeek] = useState(null);

  const toggle = useCallback(() => setIsOpen(prev => !prev), []);

  // Fetch weeks list
  useEffect(() => {
    const fetchWeeks = async () => {
      try {
        const res = await getContent(slug, product, authToken, '?depth=2');
        const allWeeksList = res.Children;

        const currentWeek = urlSlug
          ? allWeeksList.find(item => item.slug === urlSlug)
          : allWeeksList[allWeeksList.length - 1];

        const formatted = allWeeksList.map(week => {
          const { title = '', slug: weekSlug = '', data: { startTime, endTime } = {} } = week || {};
          const dateString = startTime && endTime ? ` (${getWeekNameDate(startTime, endTime)})` : '';
          const formattedTitle = weekSlug === 'getting-started' ? title : `${title}${dateString}`;
          return { ...week, title: formattedTitle };
        });

        setThisWeek(currentWeek);
        setSortedWeeksList(formatted.reverse());
      } catch (e) {
        console.error('Error fetching weeks in WeekNav:', e.message);
      }
    };

    if (slug && product && authToken) {
      fetchWeeks();
    }
  }, [slug, product, authToken, urlSlug]);

  // Loading state
  if (!sortedWeeksList) {
    return (
      <Row>
        <Col className="pagetitle">Loading Guide...</Col>
      </Row>
    );
  }

  // Empty state
  if (!sortedWeeksList.length) return null;

  return (
    <div>
      <Dropdown isOpen={isOpen} toggle={toggle}>
        <DropdownToggle caret tag="span">
          Recent Weekly Guides
        </DropdownToggle>
        <DropdownMenu right>
          {sortedWeeksList.slice(0, MAX_RECENT_WEEKS).map(week => {
            const { slug: weekSlug, title, data: { startTime, endTime } = {} } = week;
            return (
              <DropdownItem key={weekSlug} tag={Link} to={`/products/${productInPath}/${weekSlug}`}>
                {title}{' '}
                {weekSlug !== 'getting-started' && startTime && endTime && (
                  <small>{`(${getWeekNameDate(startTime, endTime)})`}</small>
                )}
              </DropdownItem>
            );
          })}
          <DropdownItem tag={Link} to={`/products/${productInPath}/weeks`}>
            View all ...
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

WeekNav.propTypes = {
  authToken: PropTypes.string.isRequired,
  product: PropTypes.string,
  slug: PropTypes.string
};

WeekNav.defaultProps = {
  product: 'wlc',
  slug: ''
};

const mapStateToProps = state => ({
  authToken: state.user.authToken
});

export default connect(mapStateToProps)(WeekNav);
